<template>
    <a-row>
        <a-col :md="12">
            <a-card title="账号信息" size="small" style="" :bordered="false">
                <a-upload
                    name="avatar" accept="image/*"
                    list-type="picture-card"
                    class="avatar-uploader"
                    :show-upload-list="false"
                    :before-upload="beforeUpload"
                    @change="handleChange"
                    action="/backend/user/avatar.php"
                >
                    <a-avatar :src="avatarURL" shape="square" :size="100" alt="avatar" />
                    <a-icon v-if="uploading" type="loading" />
                </a-upload>
                <a-descriptions>
                    <a-descriptions-item label="用户名">{{ username}}</a-descriptions-item>
                    <a-descriptions-item label="UID">{{ userid }}</a-descriptions-item>
                    <a-descriptions-item label="QQ">{{ qq }}</a-descriptions-item>
                </a-descriptions>
            </a-card>
            <a-card title="成就" size="small" :bordered="false">
                <a-row v-for="item of achievement" :key="item.id" :gutter="16" class="achievement">
                    <a-col v-if="item.type == 'text'" :title="item.details" :offset="2">
                        <a-icon :type="getIcon(item.classification)"></a-icon>
                        <span >{{ item.name }}</span>
                    </a-col>
                    <a-col v-else-if="item.type == 'img'">
                        <img :src="item.details" :title="item.name" />
                    </a-col>
                </a-row>
            </a-card>
        </a-col>
        <a-col :md="12">
            <a-card title="安全" size="small" style="" :bordered="false">
                <account-item label="密码" :has="true" comment="" @modify="modifyPassWord">
                    *******
                </account-item>
                <a-modal title="修改密码" width="360px"
                    :visible="changePassDialogVisible"
                    ok-text="修改" cancel-text="取消"
                    @ok="confirmChange" @cancel="() => changePassDialogVisible = false"
                    :confirm-loading="changing"
                >
                    <a-form-model :model="form" :rules="rules" ref="changePassForm" hideRequiredMark>
                        <a-form-model-item label="旧密码" prop="oldpass">
                            <a-input v-model="form.oldpass" type="password"></a-input>
                        </a-form-model-item>
                        <a-form-model-item label="新密码" prop="newpass">
                            <a-input v-model="form.newpass" type="password"></a-input>
                        </a-form-model-item>
                        <a-form-model-item label="确认密码" prop="confirm">
                            <a-input v-model="form.confirm" type="password"></a-input>
                        </a-form-model-item>
                    </a-form-model>
                </a-modal>
                <!-- <account-item label="邮箱" :has="!!email" comment="设置邮箱后，可通过邮箱找回密码">
                    {{ email }}
                </account-item> -->
                <account-item label="qq" :has="bindqq" comment="绑定qq后，可通过qq找回密码" @bind="helpBindQQ">
                    {{ qq }}
                </account-item>
            </a-card>
            <a-card title="操作" size="small" style="" :bordered="false">
                <a-button icon="poweroff" type="danger" @click="logout">退出登录</a-button>
            </a-card>
        </a-col>
    </a-row>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex'
import AccountItem from '../components/AccountItem.vue'

export default {
    data: () => ({
        changePassDialogVisible: false,
        changing: false,
        uploading: false,
        form: {
            oldpass: '',
            newpass: '',
            confirm: '',
        },
        rules: {
            oldpass: [
                { required: true, message: '请输入旧密码' }
            ],
            newpass: [
                { required: true, message: '请输入新密码' }
            ],
            confirm: [
                { required: true, message: '请确认新密码' },
                { validator: (rule, value, res) => {
                    if (value != this.form.newpass) {
                        res(new Error("两次输入的密码不相同"));
                    } else res();
                }, trigger: 'blur' },
            ],
        }
    }),
    computed: {
        ...mapState('$user', [
            'username', 'userid', 'email', 'qq', 'bindqq', 'achievement', 'avatarURL'
        ]),
    },
    methods: {
        bindEmail() {

        },
        getIcon(classification) {
            switch(classification) {
                case '身份': return 'idcard';
                case '拆塔比赛': return 'trophy';
                case '造塔比赛': return 'trophy';
                case '限时活动': return 'team';
                case '造塔活动': return 'team';
                case '比赛主办': return 'schedule';
                case '比赛协力': return 'schedule';
            }
        },
        async logout() {
            await axios.get("/backend/user/logout.php");
            window.location.assign("/user/login.html");
        },
        modifyPassWord() {
            this.changePassDialogVisible = true;
        },
        helpBindQQ() {
            this.$info({
                title: '如何绑定qq',
                content: h => h('div', {}, [
                    h('p', [
                        '用账号对应的qq加入',
                        h('a', {
                            attrs: {
                                href: "https://jq.qq.com/?_wv=1027&k=nJMrECRy",
                                target: "_blank"
                            }
                        }, 'h5魔塔交流群'),
                        '私聊机器人[h5魔塔助手改], 输入绑定即可进入绑定流程',
                    ]),
                ]),
                onOk() {},
            });
        },
        async confirmChange() {
            return new Promise((res, rej) => {
                this.$refs.changePassForm.validate(async (valid) => {
                    if (valid) {
                        const { data } = await axios.post("/backend/user/password.php", {
                            type: "update", oldPass: this.form.password, newPass: this.form.confirm
                        });
                        if (data.code == -1) {
                            this.$message.error("密码错误");
                        } else {
                            this.changePassDialogVisible = false;
                        }
                        res();
                    }
                })
            });
        },
        beforeUpload(file) {
            if (file.size > 1024 * 1024) {
                this.$message.error('头像最大不能超过1MB');
                return false;
            }
            return true;
        },
        handleChange(res) {
            const file = res.file;
            if (file.status == "uploading") {
                this.uploading = true;
            } else {
                this.uploading = false;
                if (file.response.code == 0) {
                    this.$message.success('文件上传成功');
                    window.location.reload();
                } else if (file.response.code == -1) {
                    this.$message.error('文件上传失败');
                } else if (file.response.code == -2) {
                    this.$message.error('文件大小超限');
                } else if (file.response.code == -3) {
                    this.$message.error('不支持的文件格式');
                }
            }
        }
    },
    components: {
        AccountItem
    }
}
</script>

<style scoped>
.ant-card {
    background: none;
}
.ant-card >>> .ant-card-head-title {
    font-size: 18px;
    font-weight: bold;
}
.ant-descriptions {
    font-size: 16px;
}
</style>